import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../services/api/cirrus-client';
import { checkDeviceAction, createDeviceAction } from './action';
import { setDeviceCredentials, setSMSNumbers } from '../../state/device/deviceSlice';
import { selectUserCredentials } from '../../state/userCredential/userCredentialSlice';

export function* checkDeviceSaga({ payload }) {
    const attemptCreate = payload?.attemptCreate ?? true;
    try {
        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);
        const device = `${user}w`;
        const response = yield call(cirrusClient.get, `?format=json&object=device&action=read&domain=${domain}&device=${device}&user=${user}`);

        if (response.data.length > 0) {
            const deviceInfo = response.data[0];
            yield put(setDeviceCredentials({
                DeviceUser: device,
                Pass: deviceInfo.authentication_key,
                Realm: deviceInfo.subscriber_domain,
                Display: deviceInfo.sub_fullname,
            }));
        } else if (attemptCreate) {
            yield put(createDeviceAction());
        } else {
            console.log('No device found and not attempting to create one.');
        }
    } catch (error) {
        console.error('Failed to check device:', error);
    }
}

export function* createDeviceSaga() {
    try {
        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);
        const device = `${user}w`;
        const body = { domain, device, user };
        yield call(cirrusClient.post, '?object=device&action=create', body);
        yield put(checkDeviceAction(false));
    } catch (error) {
        console.error('Failed to create device:', error);
    }
}

export function* fetchSMSNumberSaga() {
    try {
        const { user, domain } = yield select(selectUserCredentials);
        const response = yield call(cirrusClient.get, `?object=smsnumber&action=read&domain=${domain}&dest=${user}`);
        const smsNumbers = response.data ? response.data.map(item => item.number) : [];
        yield put(setSMSNumbers(smsNumbers));
    } catch (error) {
        console.error('Failed to fetch subscriber details:', error);
    }
}